import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { SaveButton } from "../../../components/Buttons";

export const Comission = () => {
    document.title = "Komisyon satış";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Satışlar", value: "/demands" },
        { name: "Komisyon satış", value: "/demands/comission", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Komisyon satış</h2>
                    <p>Məhsul və xidmətləri komissiya qarşılığında satmaq üçün nəzərdə tutulub.</p>
                    <h3>Misal 1</h3>
                    <p>
                        Məhsulu birbaşa təchizatçının anbarından alıcıya satmaq. Bu halda, istifadəçi məhsulu öz anbarına alış etmədən satışını həyata keçirir.
                        Komisyon satış zamanı yalnız alış və satış qiyməti qeyd olunur. Sənəd yadda saxlanıldıqdan sonra həmin təchizatçıya borc formalaşır.
                        Həmçinin satışdan qalan <b>marja</b> hesabatlarda əks olunur.
                        <ol>
                            <li>
                                Komissiya qarşılığında satılan məhsul, digər məhsullardan fərqli olaraq yaradılanda əlavə parametr hissəsində Komisyon məhsul
                                seçimi edilməlidir
                            </li>
                            <li>
                                Komisyon təyin edilən məhsulu sənədə əlavə etdikdə, hansı təchizatçıdan alındığı seçilməlidir (və həmin təchizatçıya dərhal borc
                                formalaşır).
                                <br />
                                <b>Qeyd</b>: <mark>Alış qiyməti</mark> məhsulu aldığımız məbləğdir. <mark>Satış qiyməti</mark> məhsulun satıldığı qiymətdir.
                                <mark>Faiz</mark> isə satış məbləğindən təchizatçıya verilən faizin göstəricisidir
                            </li>
                            <li>
                                Qiymətlər təyin edin və <SaveButton /> düyməsi ilə sənədi yadda saxlayın
                            </li>
                            <li>
                                <Link to={""}>Hesabatlar</Link> səhifəsində qazanc, <Link to={""}>Borclar</Link> səhifəsində borclara nəzarət edə bilərsiniz
                            </li>
                        </ol>
                    </p>
                    <img src="/images/demands/comission-1.gif" alt="Komisyon satış" />

                    <h3>Misal 2</h3>
                    <p>
                        Hər hansı bir servis xidmətində ustalar ilə faiz qarşılığında müştərilərə xidmət göstərildikdə komisyon satış zamanı ustaya veriləcək
                        faiz, xidmət icra olunan kimi borclar səhifəsində əks olunur. Həmçinin göstərilən xidmətlərdən qalan <b>marja</b>{" "}
                        <Link to={""}>Hesabatlar</Link> səhifəsində əks olunur.
                        <ol>
                            <li>
                                Yeni məhsul yaradılanda <mark>Əlavə parametr</mark> hissəsində <b>Komisyon məhsul</b> seçimi edilməlidir.
                            </li>
                            <li>
                                Komisyon məhsulu əlavə etdikdə açılan pəncərədə xidmət göstərəcək usta seçilməlidir.
                                <br />
                                <b>Qeyd</b>: Faiz qarşılığında fəaliyyət göstərən ustalara <Link to={""}>Tərəf müqabillər</Link> səhifəsində satışdan veriləcək
                                faiz təyin edilir. Komisyon satış zamanı avtomatik təyin olunan faiz ustaya borc kimi yazılır.
                            </li>
                            <li>
                                Komisyon satış sənədinə bu məhsulu əlavə edib, qiymətlər təyin edin və <SaveButton /> düyməsi ilə sənədi yadda saxlayın.
                            </li>
                            <li>
                                <Link to={""}>Hesabatlar</Link> səhifəsində qazanc, <Link to={""}>Borclar</Link> səhifəsində borclara nəzarət edə bilərsiniz
                            </li>
                        </ol>
                    </p>
                    <img src="/images/demands/comission-2.gif" alt="Komisyon satış" />

                    <h3>Misal 3</h3>
                    <p>
                        Komisyon satış sənədinə digər məhsulların əlavə edilməsi.
                        <ol>
                            <li>
                                Komisyon satış sənədinə məhsulu əlavə edib və <SaveButton /> düyməsi ilə sənədi yadda saxlayın
                            </li>
                        </ol>
                    </p>
                    <img src="/images/demands/comission-3.gif" alt="Komisyon satış" />
                </article>
            </div>
        </div>
    );
};
